import * as React from 'react';
import { useDispatch } from 'react-redux';

import { useHandlePreciseFiltersStateChange } from './useHandlePreciseFiltersStateChange';
import { IGetPreciseFiltersNextStateParams } from '../../../types/redux/preciseFilters';
import { getEstimateWithParameters } from '../../../actions/estimation';
import { TThunkDispatch } from '../../../types/redux';
import { formatEstimationPrices } from '../../../selectors/estimation/selectEstimationPrettyPrices';
import { setNotification } from '../../../actions/notification';
import { getEstimationUpdatedNotificationVarA } from '../../../utils/notifications';
import { useScrollToBlock } from '../../Scrolling';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { useIsReportStatusDefault } from '../../../utils/report';
import { setQueryParams, updateUrl } from '../../../actions/page';

export const useMainPreciseFiltersChangeHandler = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const handlePreciseFilterStateChange = useHandlePreciseFiltersStateChange();
  const scrollToBlock = useScrollToBlock();
  const isReportStatusDefault = useIsReportStatusDefault();

  return React.useCallback(
    async (params: IGetPreciseFiltersNextStateParams) => {
      handlePreciseFilterStateChange(params, true);

      if (!isReportStatusDefault) {
        return;
      }

      /**
       * При изменении фильтров сбрасываем offerId и estimationId, т.к это уже не оценка по офферу в чистом виде
       * */
      dispatch(setQueryParams({ offerId: undefined, estimationId: undefined }));
      dispatch(updateUrl());

      const res = await dispatch(getEstimateWithParameters());

      if (!(res instanceof Error) && res.data) {
        const prices = formatEstimationPrices({ ...res.data });

        dispatch(
          setNotification(
            getEstimationUpdatedNotificationVarA({
              price: prices.price,
              onActionClick: () => scrollToBlock(EScrollingBlocks.MarketPrice),
            }),
          ),
        );
      }
    },
    [dispatch, handlePreciseFilterStateChange, isReportStatusDefault, scrollToBlock],
  );
};
